import { ref } from 'vue'

export const userMessage = ref()
